import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-popover',
  templateUrl: './signup-popover.component.html',
  styleUrls: ['./signup-popover.component.scss'],
})
export class SignupPopoverComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
